import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useParams, Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../Components/Utility/Loader/Loader';
import * as action from '../Store/PurchaseOrder.action';
import { HistoryList } from './HistoryList';

function PurchaseOrderHistory() {
  const { devOrderId, poCreatedId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    loader: false,
  });

  const locaStates = location?.state;
  const list = locaStates?.list;

  useEffect(() => {
    const callFn = async () => {
      const obj = {
        poId: poCreatedId,
      };
      setState((prevState) => ({ ...prevState, loader: true }));
      const res = dispatch(action.fetchPurchaseOrderHistory(obj));
      if (res) setState((prevState) => ({ ...prevState, loader: false }));
    };
    if (!isEmpty(devOrderId) && !isEmpty(poCreatedId)) callFn();
  }, [devOrderId, poCreatedId, dispatch]);
  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('INDEX_JS.PURCHASE_HISTORY')}</h4>
        </div>
        <div className="search-filter">
          <Link
            className="cursor-pointer text-dark text-decoration-none btn btn-white btn-back-lib"
            to={
              list
                ? `/development-order/${devOrderId}/order-po-template/${poCreatedId}?list=${list}`
                : `/development-order/${devOrderId}/order-po-template/${poCreatedId}`
            }
          >
            {t('INDEX_JS.BACKS')}
          </Link>
        </div>
      </div>
      <div className="pt-4">
        <Container fluid className="px-3">
          {state.loader ? <Loader /> : <HistoryList />}
        </Container>
      </div>
    </>
  );
}

export default PurchaseOrderHistory;
